import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from 'components/authentication/LoginForm';

import AuthCardLayout from 'layouts/AuthCardLayout';
import paths from 'routes/paths';
import { useAuth } from 'hooks/useAuth';
import { Navigate } from 'react-router-dom';

const Login = () =>
{
  const { account, isLoading } = useAuth();

  if (isLoading)
  {
    return (
      <div className="spinner-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  if (account)
    return <Navigate to={paths.solutionsShowcase} replace />;
  else
    return (
      <AuthCardLayout
        leftSideContent={
          <p className="text-white">
            Don't have an account?
            <br />
            <Link
              className="text-white text-decoration-underline"
              to="#!"
            >
              Contact us!
            </Link>
          </p>
        }
      >
        <h3>Account Login</h3>
        <LoginForm />
      </AuthCardLayout>
    );
};

export default Login;
